import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/childcare-vs-working',
  component: () => import('../../routes/ChildcareWorking.svelte'),
  card: {
    id: 'childcare-vs-working',
    title: 'Childcare vs Working',
    description: 'Compare net take-home pay against daycare costs, commuting, and tax benefits.',
    icon: 'family_restroom',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/childcare-vs-working',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Childcare vs Working Calculator – Stay Home vs Return to Work',
    description: 'Free childcare vs working calculator. Compare net take-home pay against daycare costs, commuting expenses, and tax benefits. Help parents decide if returning to work is financially worthwhile after accounting for childcare.',
  },
};

export default meta;
